import { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ArticleCard from '../Articles/ArticleCard';
import LocaleContext from '../../contexts/LocaleContext';
import { getPaginatedBlogPosts, getBlogCategories } from '../../js/api/blog';
import BlogPostData from '../../models/BlogPostData';
import Icon from '../common/Icon';

export default function BlogList() {
  const { t } = useTranslation(['BlogPage']);
  const { locale } = useContext(LocaleContext);
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pageIndex, setPageIndex] = useState(1);
  const [total, setTotal] = useState(0);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState('');

  function formatPosts(data) {
    return data.map((item) => new BlogPostData(item));
  }

  function loadPosts(page, categoryId) {
    getPaginatedBlogPosts(page, categoryId)
      .then((res) => {
        setTotal(res.meta.pagination.total);
        const formatted = formatPosts(res.data);
        if (page > 1) {
          setPosts((prev) => [...prev, ...formatted]);
        } else {
          setPosts(formatted);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        toast.error(t('postsError'));
        throw e;
      });
  }

  useEffect(() => {
    setIsLoading(true);
    setPageIndex(1);
    loadPosts(1, activeCategory);
  }, [locale, activeCategory]);

  useEffect(() => {
    getBlogCategories()
      .then((res) => setCategories(res.data || []))
      .catch(() => setCategories([]));
  }, [locale]);

  function handleLoadMore() {
    const next = pageIndex + 1;
    setPageIndex(next);
    loadPosts(next, activeCategory);
  }

  function handleCategoryChange(id) {
    setActiveCategory(id);
  }

  return (
    <div className="article-list blog-list">
      {categories.length > 0 && (
        <div className="blog-list__filters container">
          <button
            type="button"
            className={`blog-list__filter ${activeCategory === '' ? 'is-active' : ''}`}
            onClick={() => handleCategoryChange('')}>
            {t('allCategories')}
          </button>
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              className={`blog-list__filter ${activeCategory === cat.id ? 'is-active' : ''}`}
              onClick={() => handleCategoryChange(cat.id)}>
              {cat.attributes?.name}
            </button>
          ))}
        </div>
      )}

      {!isLoading && posts && (
        <>
          <div className="article-list__container container">
            {posts?.map((item) => (
              <ArticleCard key={item.id} {...item} />
            ))}
          </div>

          {posts.length < total && (
            <button type="button" className="button load-more" onClick={handleLoadMore}>
              <Icon name="article" />
              {t('loadMore')}
            </button>
          )}
        </>
      )}
    </div>
  );
}
